import { useQuery } from '@apollo/client'
import { CircularProgress, Modal, Paper, Slide } from '@material-ui/core'

import { ALLOCATION_RESERVATION_LOG_DETAILS } from '../../../graphql/inventoryAllocateAvailability'
import { getDirection } from '../../../localization'
import { AllocationReservationLogDetails } from '../../../types/inventoryAllocationLogs'
import AllocateInfo from './AllocateInfo'
import ReservesModalRow from './ReservesModalRow'
import ReservesModalTableHead from './ReservesModalTableHead'
import useStyles from './styles/index.styles'

interface ReservesModalProps {
  isOpen: boolean
  onClose: () => void
  attemptID: string
  date: string
}
const ReservesModal: React.FC<ReservesModalProps> = ({
  isOpen,
  onClose,
  attemptID,
  date
}) => {
  const classes = useStyles()

  const { data } = useQuery<{
    allocationReservationLogDetails: AllocationReservationLogDetails
  }>(ALLOCATION_RESERVATION_LOG_DETAILS, {
    variables: {
      attemptId: attemptID,
      date: date
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache'
  })

  return (
    <Modal dir={getDirection()} open={isOpen} onClose={onClose}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.paper}>
          {data && (
            <AllocateInfo
              allocationDate={data?.allocationReservationLogDetails.date}
              email={data?.allocationReservationLogDetails.userEmail}
              failed={data.allocationReservationLogDetails.failed}
              name={data.allocationReservationLogDetails.name}
              requested={data.allocationReservationLogDetails.requested}
              success={data.allocationReservationLogDetails.successful}
            />
          )}

          <ReservesModalTableHead />
          {data ? (
            <>
              {data?.allocationReservationLogDetails.systemReserves.map(
                (item, index) => (
                  <ReservesModalRow data={item} index={index} />
                )
              )}
            </>
          ) : (
            <div className={classes.circularProgressContianer}>
              <CircularProgress color="primary" />
            </div>
          )}
        </Paper>
      </Slide>
    </Modal>
  )
}

export default ReservesModal
